import { getHostLocation } from "owa-url/lib/hostLocation";

// Universal Link route keys look like "<TYPE>:<value>@<tenant>" (e.g. MBX:<guid>@<tenant>,
// OID:<oid>@<tenant>, PUID:<puid>@<tenant>). They arrive in the same path position as a legacy
// explicit-logon mailbox address and, once decoded, also contain an "@", so they must NOT be
// treated as an explicit-logon mailbox. Otherwise boot would anchor startupdata.ashx to the route
// key's mailbox (which may be inaccessible to the signed-in user) and hang before the router runs.
// Kept in sync with the route key grammar in owa-mail-routing initializeMailRoutes.
const ROUTE_KEY_PREFIX = /^(?:OID|PUID|CID|MBX|APP|SPO|SCG|MSA|AAD-UPN|AAD-SMTP|TID|SMTP|TPID):/i;

export function getAnchorMailboxHeaderForExplicitLogon(): string {
    let header = "";
    
    // see if this is an explicit logon scenario, where the target mailbox is specified in the path
    // e.g., /mail/user@contoso.com/inbox/ and /mail/user%40contoso.com/inbox/
    const path = getHostLocation().pathname;
    
    const segments = path.split("/").filter(part => part.length);
    if (segments.length >= 2) {
        const testSegmentPartOne = decodeURIComponent(segments[1]);
        if (testSegmentPartOne.match(/.+@.+/) && !ROUTE_KEY_PREFIX.test(testSegmentPartOne)) {
            header = testSegmentPartOne;
        }
    }
    
    return header;
}
